import {
    useEffect,
    useState,
} from 'react'

const useDebouncedValue = <T>(value: T, delay: number): T => {
    const [
        debouncedValue,
        setDebouncedValue,
    ] = useState(value)

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(value)
        }, delay)

        return () => {
            clearTimeout(timer)
        }
    }, [
        value,
        delay,
    ])

    return debouncedValue
}

export default useDebouncedValue
